<li class="m-radio"
    :class="{
        'm--is-disabled': propDisabled,
        'm--is-readonly': propReadonly,
        'm--is-error': propError,
        'm--is-valid': propValid,
        'm--is-checked': isChecked,
        'm--is-focus': hasFocus && !propDisabled,
        'm--is-input-right': propPosition === 'right',
        'm--is-inline': propInline,
        'm--is-align-center': propVerticalAlign === 'center'
    }"
>
    <input
        ref="radioInput"
        v-model="model"
        :id="id"
        class="m-radio__hidden"
        type="radio"
        :disabled="propDisabled || isReadonlyUnchecked"
        :name="propName"
        :value="value"
        :aria-invalid="propError"
        :aria-describedby="inputAriaDescribedby"
        @focus="onFocus"
        @blur="onBlur"
    />
    <label class="m-radio__wrap"
           ref="label"
           :for="id">
        <span class="m-radio__input"
              :style="{ 'margin-top': propRadioMarginTop }"
              aria-hidden="true"></span>
        <span class="m-radio__label">
            <slot/>
        </span>
    </label>
</li>
